import styled from 'styled-components';

const FieldNameContainer = styled.span`
  &,
  span {
    display: inline-flex;
    align-items: center;
  }

  > :nth-child(2) {
    margin-left: 0.2em;
  }
`;

export default FieldNameContainer;
